import { Component, OnInit } from '@angular/core';
import { NeoParametrizacionLineaDTO } from '../../Model/neoParametrizacionLineaDTO';
import { NeoTipoCargo } from '../../../comun/models/neoTipoCargo';
import { NeoPropuestaIntermediario } from '../../Model/neoPropuestaIntermediario';
import { NeoPropuesta } from '../../Model/neoPropuesta';
import { NeoCargo } from '../../Model/neoCargo';
import { NeoIntermediarioFinancieroService } from '../../Service/neoIntermediarioFinanciero.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NeoTipoPeriodicidadDTO } from '../../Model/neoTipoPeriodicidadDTO';
import { NeoCalcularCuota } from '../../Model/neoCalcularCuota';
import { ModalidadBancoldexDTO } from '../../Model/modalidadBancoldexDTO';
import { DestinoBancoldexDTO } from '../../Model/destinoBancoldex';
import { ModalidadXDestino } from '../../Model/modalidadXDestino';
import { PlazoBancoldex } from '../../Model/plazoBancoldex';
import { PeriodicidadBancoldex } from '../../Model/periodicidadBancoldex';
import { TasaRedescuentoBancoldex } from '../../Model/tasaRedescuentoBancoldex';
import { DatosTasaBancoldex } from '../../Model/datosTasaBancoldex';
import { PeriodoGraciaBancoldex } from '../../Model/periodoGraciaBancoldex';
import { NeoComunService } from '../../../comun/services/neoComun.service';
import { UntypedFormControl } from '@angular/forms';
import { CurrencyPipe } from '@angular/common';
import { MicroempresarioService } from '../../../microempresario/services/microempresario.service';
import { RouterService } from '../../../services/router.service';
import { ParametrosService } from 'src/app/services/parametros.service';
import { UserService } from '../../../services/user.service';
import { NeoParametrizacionCondicionIntermediario } from "../../../comun/models/NeoParametrizacionCondicionIntermediario";
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
import { BancoldexService } from 'src/app/comun/services/bancoldex.service';
import { TrazabilidadAuditoriaService } from '../../Service/trazabilidad-auditoria.service';
import { NeoTrazabilidadAuditoriaDTO } from '../../Model/neoTrazabilidadAuditoriaDTO';
import { Constantes } from 'src/app/comun/data/constantes';
declare var $: any;
const DTF_BANCA = 17;
const DTF_T24 = 7;
const IBR_BANCA = 108;
const IBR_T24 = 34;

@Component({
    selector: 'app-propuesta-intermediario',
    templateUrl: './propuesta-intermediario.component.html',
    styleUrls: ['./propuesta-intermediario.component.scss'],
    providers: [
        NeoIntermediarioFinancieroService,
        NeoComunService,
        MicroempresarioService,
    ],
    standalone: false
})
export class PropuestaIntermediarioComponent implements OnInit {
  public tiposCargo: NeoTipoCargo[] = [];
  public tiposCondicion: NeoParametrizacionCondicionIntermediario[] = [];
  public detalleSolcitud: any;
  public observacionesAprobadorPropios: string = '';
  public observacionesAprobadorBancoldex: string = '';
  idSolicitud: string;
  idCupoBancoldex: number;
  selectedOption: string;
  optionsVisible: boolean = false;
  mensajeError: string = "";
  mensajeTasa: string = "";
  mensajeRecursosBancoldex: string = "";
  errorTasaMax: boolean = false;

  //propios
  public lineasPropias: NeoParametrizacionLineaDTO[] = [];
  public plazosLineaPropia: number[] = [];
  public periodosGraciaLineaPropia: number[] = [];
  public tasasLineaPropia: number[] = [];
  public periodicidadesLineaPropia: NeoTipoPeriodicidadDTO[] = [];
  public cargosGarantiasLineaPropia: NeoCargo[] = [];
  public cargosGarantiasLineaPropiaConNombre: any[] = [];
  public neoPropuestaIntermediarioPropios: NeoPropuestaIntermediario;
  public cargoGarantiasPropiosNuevo: NeoCargo;
  public neoCalcularCuota: NeoCalcularCuota;
  aprobarBancoldex = false;
  aprobarPropios = false;
  public user;
  habilitarCargosGarantias: boolean = false;
  valor: UntypedFormControl;
  montoPropios: string = '';

  //bancoldex
  public lineasBancoldex: ModalidadBancoldexDTO[] = [];
  public neoPropuestaIntermediarioBancoldex: NeoPropuestaIntermediario;
  public plazosLineaBancoldex: PlazoBancoldex[] = [];
  public destinosBancoldex: DestinoBancoldexDTO[] = [];
  public modalidadXDestino: ModalidadXDestino;
  public periodicidadesBancoldex: PeriodicidadBancoldex[] = [];
  public datosTasaBancoldex: DatosTasaBancoldex;
  public periodosGraciaBancoldex: PeriodoGraciaBancoldex[] = [];
  public tasaRedescuentoBancoldex: TasaRedescuentoBancoldex;
  public tasaBancoldex: number;
  public cargoGarantiasBancoldexNuevo: NeoCargo;
  public cargosGarantiasLineaBancoldexConNombre: any[] = [];
  public cargosGarantiasLineaBancoldex: NeoCargo[] = [];
  public neoCalcularCuotaBancoldex: NeoCalcularCuota;
  habilitarCargosGarantiasBancoldex: boolean = false;
  editandoPropuesta: boolean = false;
  origenRecursos = 'null';
  tasaRedescuentoEABancoldex: string = '';
  editandoPropuestaBancoldex: boolean = false;
  montoBancoldex: string = '';
  sucursalesBancoldex: any[] = [];
  idCupoBancoldexVerificado: number;

  idTrazabilidad: number = 0;

  isTransaccional: boolean = false;

  constructor(
    private readonly _neoParametrosService: ParametrosService,
    private readonly _userIntermediarioService: UserService,
    private readonly _neoIntermediarioFinancieroService: NeoIntermediarioFinancieroService,
    private readonly _route: ActivatedRoute,
    private readonly _router: Router,
    public pipe: CurrencyPipe,
    private readonly _microempresario: MicroempresarioService,
    private readonly routerService: RouterService,
    private readonly _sweetAlert: SweetAlertService,
    private readonly _bancoldexService: BancoldexService,
    private readonly _serviceTrazabilidad: TrazabilidadAuditoriaService
  ) {
    this.getMensajeTasa();
    this.user = this._userIntermediarioService.getUser();
    this.inicializarPropios();
    this.inicializarBancoldex();
    this.loadSelectPiker();
    this.valor = new UntypedFormControl({ value: '' });
    this.idCupoBancoldex = this.user.cupoBancoldex;
    const nav = this._router.getCurrentNavigation();
    this.isTransaccional = nav?.extras.state?.['from'] === Constantes.TRANSACCIONAL;
  }

  inicializarPropios() {
    this.cargoGarantiasPropiosNuevo = new NeoCargo('', null, 0, 0);
    this.neoPropuestaIntermediarioPropios = new NeoPropuestaIntermediario(
      new NeoPropuesta(
        null,
        null,
        0,
        0,
        'null',
        null,
        0,
        null,
        null,
        0,
        0,
        null,
        '',
        0,
        null,
        '',
        null,
        '',
        ''
      ),
      null,
      null,
      '',
      null
    );
    this.neoCalcularCuota = new NeoCalcularCuota(null, null, null, null);
  }

  inicializarBancoldex() {
    this.cargoGarantiasBancoldexNuevo = new NeoCargo('', null, 0, 0);
    this.neoPropuestaIntermediarioBancoldex = new NeoPropuestaIntermediario(
      new NeoPropuesta(
        null,
        null,
        0,
        0,
        'null',
        null,
        null,
        0,
        0,
        0,
        0,
        0,
        '',
        0,
        null,
        '',
        null,
        '',
        '',
        0
      ),
      null,
      null,
      '',
      null
    );
    this.modalidadXDestino = new ModalidadXDestino(null, null, null);
    this.datosTasaBancoldex = new DatosTasaBancoldex(null, null, null, null);
    this.tasaRedescuentoBancoldex = new TasaRedescuentoBancoldex(
      null,
      '',
      null
    );
    this.neoCalcularCuotaBancoldex = new NeoCalcularCuota(
      null,
      null,
      null,
      null
    );
  }

  ngOnInit(): void {
    this._route.params.subscribe((params: Params) => {
      this.neoPropuestaIntermediarioPropios.idSolicitud = params['id'];
      this.neoPropuestaIntermediarioBancoldex.idSolicitud = params['id'];
      this.idSolicitud = params['id'];
    });
    const datosDetalleSolicitud = {
      idSolicitud: this.neoPropuestaIntermediarioPropios.idSolicitud,
      idCliente: Number(this.user.idCliente),
      idUsuario: Number(this.user.idUsuario),
      idParametrizacionCondicion: Number(this.user.idParametrizacionCondicion),
    };

    this._neoIntermediarioFinancieroService
      .detalleAprobador(datosDetalleSolicitud)
      .subscribe(
        (response) => {
          return new Promise((resolve, reject) => {
            if (response['exitoso']) {
              this.detalleSolcitud = response['data'];
              if (this.detalleSolcitud.propuesta != null) {
                if (
                  this.detalleSolcitud.propuesta.origenRecursos ==
                  'RECURSOS_PROPIOS'
                ) {
                  this.editandoPropuesta = true;
                  this.cargarPropuestaPropios();
                } else if (
                  this.detalleSolcitud.propuesta.origenRecursos ==
                  'RECURSOS_BANCOLDEX'
                ) {
                  this.editandoPropuestaBancoldex = true;
                  this.cargarPropuestaBancoldex();
                }
              }
              this.revisionOferta(
                this.detalleSolcitud.solicitud.idEstadoSolicitud_NeoEstadoSolicitud,
                this.detalleSolcitud.negacion,
                this.detalleSolcitud.propuesta
              );
              this.correccionAprobacionOferta(
                this.detalleSolcitud.solicitud.idEstadoSolicitud_NeoEstadoSolicitud,
                this.detalleSolcitud.negacion,
                this.detalleSolcitud.propuesta
              );

              this.alertaModalidadesBancoldex(this.detalleSolcitud.solicitud.idSolicitud);
            } else {
              this._router.navigate(['intermediario/home']);
            }
          });
        },
        (error) => {
          this._router.navigate(['intermediario/home']);
        },
        () => {
          setTimeout(() => {
            $('.selectpicker').selectpicker('refresh');
          });
        }
      );
    this.cargarNombresGarantia();
  }

  cargarPropuestaPropios() {

    this.origenRecursos = 'Propios';
    if (this.detalleSolcitud.observacionAprobador.observaciones != null) {
      this.observacionesAprobadorPropios =
        this.detalleSolcitud.observacionAprobador.observaciones;
    }

    this.neoPropuestaIntermediarioPropios = new NeoPropuestaIntermediario(
      new NeoPropuesta(
        this.detalleSolcitud.propuesta.idPropuesta,
        this.detalleSolcitud.propuesta.cuota,
        this.detalleSolcitud.propuesta.plazo,
        this.detalleSolcitud.propuesta.tasa,
        this.detalleSolcitud.propuesta.origenRecursos,
        this.detalleSolcitud.propuesta.monto,

        this.detalleSolcitud.propuesta.idParametrizacionLinea,
        null,
        null,
        this.detalleSolcitud.propuesta.periodicidad,
        this.detalleSolcitud.propuesta.periodoGracia,
        null,
        this.detalleSolcitud.propuesta.observaciones,
        this.detalleSolcitud.propuesta.desembolsoAproximado,
        null,
        '',
        null,
        '',
        ''
      ),
      this.cargosGarantiasLineaPropia,
      this.user.idCliente,
      this.detalleSolcitud.solicitud.idSolicitud,
      this.user.idUsuario
    );
    this.montoPropios = this.detalleSolcitud.propuesta.monto;
    this.cargoGarantiasPropiosNuevo = new NeoCargo('', null, 0, 0);
    this.neoCalcularCuota = new NeoCalcularCuota(null, null, null, null);
    this.cargarLineas('Propios');
    this.cargarDatosLineaPropia(
      this.neoPropuestaIntermediarioPropios.propuesta.idParametrizacionLinea
    );
    this.habilitarCargosGarantias = true;
    this.loadSelectPiker();
  }

  cargarCargosGarantiasPropios() {
    this.detalleSolcitud.propuesta.neoCargoComisiones.forEach(
      (element, index) => {
        const neocargo = {
          descripcion: element.descripcion,
          monto: element.monto,
          idTipoCargo_NeoTipoCargo: element.idTipoCargo_NeoTipoCargo,
          idParametrizacionCondicion: element.idParametrizacionCondicion,
        };
        this.cargosGarantiasLineaPropia.push(neocargo);
        this.cargoGarantiasPropiosNuevoANombre(neocargo);
      }
    );
  }

  cargarPropuestaBancoldex() {
    this.origenRecursos = 'Bancoldex';
    if (this.detalleSolcitud.observacionAprobador.observaciones != null) {
      this.observacionesAprobadorBancoldex =
        this.detalleSolcitud.observacionAprobador.motivoDevolucion +
        ':\n' +
        this.detalleSolcitud.observacionAprobador.observaciones;
    }
    this.neoPropuestaIntermediarioBancoldex = new NeoPropuestaIntermediario(
      new NeoPropuesta(
        this.detalleSolcitud.propuesta.idPropuesta,
        this.detalleSolcitud.propuesta.cuota,
        this.detalleSolcitud.propuesta.plazo,
        this.detalleSolcitud.propuesta.tasa,
        this.detalleSolcitud.propuesta.origenRecursos,
        this.detalleSolcitud.propuesta.monto,
        null,
        this.detalleSolcitud.propuesta.idLineaBancoldex,
        this.detalleSolcitud.propuesta.idDestino,
        this.detalleSolcitud.propuesta.periodicidad,
        this.detalleSolcitud.propuesta.periodoGracia,
        this.detalleSolcitud.propuesta.puntosAdicionales,
        this.detalleSolcitud.propuesta.observaciones,
        this.detalleSolcitud.propuesta.desembolsoAproximado,
        this.detalleSolcitud.propuesta.margenIntermediario,
        this.detalleSolcitud.propuesta.tasaRedescuento,
        this.detalleSolcitud.propuesta.codigoTasaRedescuento,
        this.detalleSolcitud.propuesta.modalidad,
        this.detalleSolcitud.propuesta.destino,
        this.detalleSolcitud.propuesta.idSucursal
      ),
      this.cargosGarantiasLineaBancoldex,
      this.user.idCliente,
      this.detalleSolcitud.solicitud.idSolicitud,
      this.user.idUsuario
    );
    this.montoBancoldex = this.detalleSolcitud.propuesta.monto;
    this.cargoGarantiasBancoldexNuevo = new NeoCargo('', null, 0, 0);
    this.neoCalcularCuotaBancoldex = new NeoCalcularCuota(
      null,
      null,
      null,
      null
    );
    this.cargarLineas('Bancoldex');
    this.cargarDestinosModalidadBancoldex(
      this.detalleSolcitud.propuesta.idLineaBancoldex
    );
    this.habilitarCargosGarantiasBancoldex = true;
    this.tasaRedescuentoEABancoldex =
      this.detalleSolcitud.propuesta.tasaRedescuento +
      ' + ' +
      this.detalleSolcitud.propuesta.puntosAdicionales;
    if (DTF_BANCA == this.detalleSolcitud.propuesta.codigoTasaRedescuento) {
      this.cargarTasaBancoldex(String(DTF_T24));
    } else if (
      IBR_BANCA == this.detalleSolcitud.propuesta.codigoTasaRedescuento
    ) {
      this.cargarTasaBancoldex(String(IBR_T24));
    }
    this.loadSelectPiker();
  }

  cargarCargosGarantiasBancoldex() {
    this.detalleSolcitud.propuesta.neoCargoComisiones.forEach(
      (element, index) => {
        const neocargo = {
          descripcion: element.descripcion,
          monto: element.monto,
          idTipoCargo_NeoTipoCargo: element.idTipoCargo_NeoTipoCargo,
          idParametrizacionCondicion: element.idParametrizacionCondicion,
        };
        this.cargosGarantiasLineaBancoldex.push(neocargo);
        this.cargoGarantiasBancoldexNuevoANombre(neocargo);
      }
    );
  }

  cargarLineas(i) {
    if (i != 'null') {
      this._neoParametrosService.getTiposCargo().subscribe(
        (response) => {
          return new Promise((resolve, reject) => {
            this.tiposCargo = response;
            if (this.editandoPropuesta) {
              this.cargarCargosGarantiasPropios();
            } else if (this.editandoPropuestaBancoldex) {
              this.cargarCargosGarantiasBancoldex();
            }
          });
        },
        (error) => {
          this._sweetAlert.errorModal("Error!", true,
            'No fue posible cargar los tipos de cargos y/o garantias'
          );
        },
        () => {
          setTimeout(() => {
            $('.selectpicker').selectpicker('refresh');
          });
        }
      );
    }
    this.loadSelectPiker();
    if (i == 'Propios') {
      this.neoPropuestaIntermediarioPropios.propuesta.origenRecursos =
        this.origenRecursos;
      this._neoParametrosService.getLineasIFHabilitadas(this.user.idCliente).subscribe(
        (response) => {
          this.lineasPropias = response;
        },
        (error) => {
          this._sweetAlert.errorModal("Error!", true, 'No fue posible cargar las lineas de credito');
        },
        () => {
          setTimeout(() => {
            $('.selectpicker').selectpicker('refresh');
          });
        }
      );
    }
    if (i == 'Bancoldex') {
      this.neoPropuestaIntermediarioBancoldex.propuesta.origenRecursos =
        this.origenRecursos;
      this._neoParametrosService
        .getModalidadesBancoldex(this.user.idCliente, this.detalleSolcitud.solicitud.idSolicitud)
        .subscribe(
          (response) => {
            if (response['exitoso']) {
              this.lineasBancoldex = response['data'];
            } else {
              this._sweetAlert.errorModal("Error!", true, response['error']);
            }
          },
          (error) => {
            this._sweetAlert.errorModal("Error!", true,
              'No fue posible cargar las lineas de credito'
            );
          },
          () => {
            setTimeout(() => {
              $('.selectpicker').selectpicker('refresh');
            });
          }
        );
    }
  }

  cargarNombresGarantia() {
    this._neoParametrosService.getTiposCondicion(this.user.idCliente).subscribe((response: any) => {
      this.tiposCondicion = response;
    });
  }

  cargarDatosLineaPropia(i) {
    if (i == 0) {
      this.plazosLineaPropia = [];
      this.periodosGraciaLineaPropia = [];
      this.tasasLineaPropia = [];
      this.periodicidadesLineaPropia = [];
      this.neoPropuestaIntermediarioPropios.propuesta.plazo = null;
      this.neoPropuestaIntermediarioPropios.propuesta.tasa = null;
      this.neoPropuestaIntermediarioPropios.propuesta.periodicidad = null;
      this.neoPropuestaIntermediarioPropios.propuesta.periodoGracia = null;
      this.loadSelectPiker();
    } else {
      this._neoParametrosService.getPlazoLinea(i).subscribe(
        (response) => {
          this.plazosLineaPropia = response;
        },
        (error) => {
          this._sweetAlert.errorModal("Error!", true, 'No fue posible cargar los plazos');
          this.plazosLineaPropia = [];
        },
        () => {
          setTimeout(() => {
            $('.selectpicker').selectpicker('refresh');
          });
        }
      );
      this._neoParametrosService.getPeriodosGraciaLinea(i).subscribe(
        (response) => {
          this.periodosGraciaLineaPropia = response;
        },
        (error) => {
          this._sweetAlert.errorModal("Error!", true,
            'No fue posible cargar los periodos de gracia'
          );
          this.periodosGraciaLineaPropia = [];
        },
        () => {
          setTimeout(() => {
            $('.selectpicker').selectpicker('refresh');
          });
        }
      );
      this._neoParametrosService.getTasaLinea(i).subscribe(
        (response) => {
          this.tasasLineaPropia = response;
        },
        (error) => {
          this._sweetAlert.errorModal("Error!", true, 'No fue posible cargar las tasas');
          this.tasasLineaPropia = [];
        },
        () => {
          setTimeout(() => {
            $('.selectpicker').selectpicker('refresh');
          });
        }
      );
      this._neoParametrosService.getTiposPeriodicidadLinea(i).subscribe(
        (response) => {
          this.periodicidadesLineaPropia = response;
        },
        (error) => {
          this._sweetAlert.errorModal("Error!", true, 'No fue posible cargar las periodicidades');
          this.periodicidadesLineaPropia = [];
        },
        () => {
          setTimeout(() => {
            $('.selectpicker').selectpicker('refresh');
          });
        }
      );
    }
  }

  loadSelectPiker() {
    setTimeout(() => {
      $('.selectpicker').selectpicker('refresh');
    });
  }

  siguienteBancoldex() {
    if (this.propuestaVaciaBancoldex()) {
      this.aprobarBancoldex = true;
      $('#formulario-bancoldex :input').prop('readonly', true);
      $('#formulario-bancoldex :button').prop('disabled', true);
      $('#formulario-bancoldex >select').prop('disabled', true);
      $('.selectpicker').prop('disabled', true);
      this.loadSelectPiker();
      this.loadSelectPiker();
      this.neoPropuestaIntermediarioBancoldex.idCliente = this.user.idCliente;
      this.neoPropuestaIntermediarioBancoldex.idUsuario = this.user.idUsuario;
      this.neoPropuestaIntermediarioBancoldex.cargos =
        this.cargosGarantiasLineaBancoldex;
    } else {
      this._sweetAlert.errorModal("Error!", true, 'Faltan campos por llenar');
    }
  }

  propuestaVaciaBancoldex(): boolean {
    if (
      this.neoPropuestaIntermediarioBancoldex.propuesta.idLineaBancoldex != 0 &&
      this.neoPropuestaIntermediarioBancoldex.propuesta.monto != 0 &&
      this.neoPropuestaIntermediarioBancoldex.propuesta.monto != null &&
      this.neoPropuestaIntermediarioBancoldex.propuesta.plazo != 0 &&
      this.neoPropuestaIntermediarioBancoldex.propuesta.tasa != 0 &&
      this.neoPropuestaIntermediarioBancoldex.propuesta.periodicidad != 0
    ) {
      return true;
    } else {
      return false;
    }
  }

  limpiarRecPropios() {
    this.neoPropuestaIntermediarioPropios.propuesta = new NeoPropuesta(
      null,
      null,
      null,
      null,
      '',
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      '',
      0,
      null,
      '',
      null,
      '',
      ''
    );
    this.cargosGarantiasLineaPropia = [];
    this.cargosGarantiasLineaPropiaConNombre = [];
    this.origenRecursos = 'null';
    this.inicializarPropios();
    this.inicializarBancoldex();
    this.loadSelectPiker();
  }

  anterior() {
    //this.limpiarRecPropios();
    this.origenRecursos = 'null';
    this.loadSelectPiker();
  }

  anteriorBancoldex2() {
    this.aprobarBancoldex = false;
    $('#formulario-bancoldex :input').prop('readonly', false);
    $('#formulario-bancoldex :button').prop('disabled', false);
    $('#formulario-bancoldex >select').prop('disabled', false);
    $('.selectpicker').prop('disabled', false);
    this.loadSelectPiker();
  }

  propuestaVacia(): boolean {
    const tasa = this.neoPropuestaIntermediarioPropios.propuesta.tasa;
    if (
      this.neoPropuestaIntermediarioPropios.propuesta.idParametrizacionLinea !=
      null &&
      (this.neoPropuestaIntermediarioPropios.propuesta.monto != 0 ||
        this.neoPropuestaIntermediarioPropios.propuesta.monto != null) &&
      (this.neoPropuestaIntermediarioPropios.propuesta.plazo != null ||
        this.neoPropuestaIntermediarioPropios.propuesta.plazo != 0) &&
      (this.neoPropuestaIntermediarioPropios.propuesta.tasa != 0 &&
        this.neoPropuestaIntermediarioPropios.propuesta.tasa != null &&
        !isNaN(tasa.valueOf())) &&
      (this.neoPropuestaIntermediarioPropios.propuesta.periodicidad != 0 ||
        this.neoPropuestaIntermediarioPropios.propuesta.periodicidad != null) &&
      (this.neoPropuestaIntermediarioPropios.propuesta.desembolsoAproximado !=
        null ||
        this.neoPropuestaIntermediarioPropios.propuesta.desembolsoAproximado !=
        0) &&
      (this.neoPropuestaIntermediarioPropios.propuesta.cuota != null ||
        this.neoPropuestaIntermediarioPropios.propuesta.cuota != 0)
    ) {
      return false;
    } else {
      return true;
    }
  }

  siguientePropios() {
    if (!this.propuestaVacia()) {
      this.aprobarPropios = true;
      $('#formulario-propios :input').prop('disabled', true);
      $('#formulario-propios :button').prop('disabled', true);
      $('#formulario-propios >select').prop('disabled', true);
      $('.selectpicker').prop('disabled', true);
      this.loadSelectPiker();
      this.neoPropuestaIntermediarioPropios.idCliente = this.user.idCliente;
      this.neoPropuestaIntermediarioPropios.idUsuario = this.user.idUsuario;
      this.neoPropuestaIntermediarioPropios.cargos =
        this.cargosGarantiasLineaPropia;
    } else {
      this._sweetAlert.errorModal("Error!", true, 'Faltan campos por llenar');
    }
  }

  anteriorPropios2() {
    this.aprobarPropios = false;
    $('#formulario-propios :input').prop('disabled', false);
    $('#formulario-propios :button').prop('disabled', false);
    $('#formulario-propios >select').prop('disabled', false);
    $('.selectpicker').prop('disabled', false);
    this.loadSelectPiker();
  }

  agregarCargosGarantiasLineaPropia() {
    if (
      (this.cargoGarantiasPropiosNuevo.descripcion != '' || this.cargoGarantiasPropiosNuevo.idParametrizacionCondicion != 0) && (
        this.cargoGarantiasPropiosNuevo.idTipoCargo_NeoTipoCargo != 0 &&
        this.cargoGarantiasPropiosNuevo.monto != null &&
        this.cargoGarantiasPropiosNuevo.monto != 0 &&
        this.cargoGarantiasPropiosNuevo.monto)
    ) {
      const monto = String(this.cargoGarantiasPropiosNuevo.monto)
        .replace(',', '')
        .replace(',', '')
        .replace(',', '')
        .replace(',', '')
        .replace('.', '')
        .replace('.', '')
        .replace('.', '')
        .replace('.', '')
        .replace('$', '').trim();
      this.cargoGarantiasPropiosNuevo.monto = Number(monto);
      this.cargoGarantiasPropiosNuevoANombre(this.cargoGarantiasPropiosNuevo);
      this.cargosGarantiasLineaPropia.push(this.cargoGarantiasPropiosNuevo);
      if (this.cargoGarantiasPropiosNuevo.idTipoCargo_NeoTipoCargo == 2) {
        this.neoPropuestaIntermediarioPropios.propuesta.desembolsoAproximado =
          this.neoPropuestaIntermediarioPropios.propuesta.desembolsoAproximado.valueOf() -
          this.cargoGarantiasPropiosNuevo.monto.valueOf();
      } else if (
        this.cargoGarantiasPropiosNuevo.idTipoCargo_NeoTipoCargo == 1
      ) {
        this.neoPropuestaIntermediarioPropios.propuesta.cuota =
          this.neoPropuestaIntermediarioPropios.propuesta.cuota.valueOf() +
          this.cargoGarantiasPropiosNuevo.monto.valueOf();
      }
      this.cargoGarantiasPropiosNuevo = new NeoCargo('', null, 0, 0);
      this.loadSelectPiker();
    } else {
      this._sweetAlert.errorModal("Error!", true, 'Por favor diligencie todos los campos');
      if (!this.cargoGarantiasPropiosNuevo.monto)
        this.cargoGarantiasPropiosNuevo.monto = null;
      this.setPipeMontoGarantiaPropios();
    }
  }

  borrarCargosGarantiasLineaPropia(i) {
    if (this.cargosGarantiasLineaPropia[i].idTipoCargo_NeoTipoCargo == 2) {
      this.neoPropuestaIntermediarioPropios.propuesta.desembolsoAproximado =
        this.neoPropuestaIntermediarioPropios.propuesta.desembolsoAproximado.valueOf() +
        this.cargosGarantiasLineaPropia[i].monto.valueOf();
    } else if (
      this.cargosGarantiasLineaPropia[i].idTipoCargo_NeoTipoCargo == 1
    ) {
      this.neoPropuestaIntermediarioPropios.propuesta.cuota =
        this.neoPropuestaIntermediarioPropios.propuesta.cuota.valueOf() -
        this.cargosGarantiasLineaPropia[i].monto.valueOf();
    }
    this.cargosGarantiasLineaPropia.splice(i, 1);
    this.cargosGarantiasLineaPropiaConNombre.splice(i, 1);
  }

  cargoGarantiasPropiosNuevoANombre(cargoGarantiasPropiosNuevo: NeoCargo) {
    const cargoGarantiaPropiosNombre = {
      descripcion: '',
      monto: null,
      nombreTipoCargo: '',
    };
    this.tiposCargo.forEach((tipoCargo) => {
      if (
        tipoCargo.idTipoCargo ==
        cargoGarantiasPropiosNuevo.idTipoCargo_NeoTipoCargo
      ) {
        cargoGarantiaPropiosNombre.nombreTipoCargo =
          tipoCargo.nombre.toString();

      }
    });
    if (cargoGarantiasPropiosNuevo.idParametrizacionCondicion != null && cargoGarantiasPropiosNuevo.idParametrizacionCondicion != 0) {
      this.tiposCondicion.forEach((tipoCondicion) => {

        if (
          tipoCondicion.idParametrizacionCondicion ==
          cargoGarantiasPropiosNuevo.idParametrizacionCondicion
        ) {
          cargoGarantiaPropiosNombre.descripcion =
            tipoCondicion.nombre.toString();
          cargoGarantiasPropiosNuevo.descripcion =
            tipoCondicion.nombre.toString();
        }
      });
    } else {
      cargoGarantiasPropiosNuevo.idParametrizacionCondicion = null;
      cargoGarantiaPropiosNombre.descripcion = cargoGarantiasPropiosNuevo.descripcion.toString();
      cargoGarantiasPropiosNuevo.descripcion = cargoGarantiasPropiosNuevo.descripcion.toString();
    }
    cargoGarantiaPropiosNombre.monto = cargoGarantiasPropiosNuevo.monto;
    this.cargosGarantiasLineaPropiaConNombre.push(
      cargoGarantiaPropiosNombre
    );
  }

  aprobarSolicitudRecPropios() {
    if (this.neoPropuestaIntermediarioPropios.propuesta.observaciones != '') {
      this._neoIntermediarioFinancieroService
        .crearPropuesta(this.neoPropuestaIntermediarioPropios)
        .subscribe(
          (response) => {
            if (response['exitoso'] == true) {
              this._sweetAlert.successModal('¡Éxito!',
                false,
                'La oferta ha sido enviada para aprobación correctamente').then(
                  (result) => {
                    if (result.isConfirmed) {
                      this._router.navigate(['/intermediario/home']);
                    }
                  });
              // Consumir servicio para finalizar auditoria
              this.cerrarTrazabilidad(this.idTrazabilidad);
              // $('#aceptarModal').modal('show');
            } else {
              this._sweetAlert.errorModal("Error!", true, 'No fue posible enviar la propuesta');
            }
          },
          (error) => {
            this._sweetAlert.errorModal("Error!", true, 'No fue posible enviar la propuesta');
          }
        );
    } else {
      this._sweetAlert.errorModal("Error!", true, 'Por favor diligencie las observaciones');
    }
  }

  aceptar() {
    $('#aceptarModal').modal('hide');
    this._router.navigate(['/intermediario/home']);
  }

  calcularCuota() {
    const monto = String(this.montoPropios)
      .replace(',', '')
      .replace(',', '')
      .replace(',', '')
      .replace(',', '')
      .replace('.', '')
      .replace('.', '')
      .replace('.', '')
      .replace('.', '')
      .replace('$', '').trim();
    this.neoPropuestaIntermediarioPropios.propuesta.monto = Number(monto);
    if (
      this.neoPropuestaIntermediarioPropios.propuesta.monto != null &&
      this.neoPropuestaIntermediarioPropios.propuesta.monto != 0
    ) {
      this.neoPropuestaIntermediarioPropios.propuesta.desembolsoAproximado =
        this.neoPropuestaIntermediarioPropios.propuesta.monto;
      if (this.cargosGarantiasLineaPropia.length > 0) {
        this.cargosGarantiasLineaPropia.forEach((cargoGarantia) => {
          if (cargoGarantia.idTipoCargo_NeoTipoCargo == 2) {
            this.neoPropuestaIntermediarioPropios.propuesta.desembolsoAproximado =
              this.neoPropuestaIntermediarioPropios.propuesta.desembolsoAproximado.valueOf() -
              cargoGarantia.monto.valueOf();
          }
        });
      }
    }
    if (
      this.neoPropuestaIntermediarioPropios.propuesta.monto != null &&
      this.neoPropuestaIntermediarioPropios.propuesta.monto != 0 &&
      this.neoPropuestaIntermediarioPropios.propuesta.plazo != 0 &&
      this.neoPropuestaIntermediarioPropios.propuesta.tasa != 0 &&
      this.neoPropuestaIntermediarioPropios.propuesta.periodicidad != 0
    ) {
      this.neoCalcularCuota.monto =
        this.neoPropuestaIntermediarioPropios.propuesta.monto;
      this.neoCalcularCuota.plazo = Number(
        this.neoPropuestaIntermediarioPropios.propuesta.plazo
      );
      this.neoCalcularCuota.tasafinalEA = Number(
        this.neoPropuestaIntermediarioPropios.propuesta.tasa
      );
      this.neoCalcularCuota.periodicidad = Number(
        this.neoPropuestaIntermediarioPropios.propuesta.periodicidad
      );
      this._neoIntermediarioFinancieroService
        .coutaRecursosPropios(this.neoCalcularCuota)
        .subscribe(
          (response) => {
            if (response['exitoso']) {
              this.neoPropuestaIntermediarioPropios.propuesta.cuota =
                response['cuotaAproximada'];
              if (this.cargosGarantiasLineaPropia.length > 0) {
                this.cargosGarantiasLineaPropia.forEach((cargoGarantia) => {
                  if (cargoGarantia.idTipoCargo_NeoTipoCargo == 1) {
                    this.neoPropuestaIntermediarioPropios.propuesta.cuota =
                      this.neoPropuestaIntermediarioPropios.propuesta.cuota.valueOf() +
                      cargoGarantia.monto.valueOf();
                  }
                });
              }
              this.habilitarCargosGarantias = true;
            } else {
              this._sweetAlert.errorModal("Error!", true, response['error']);
            }
          },
          (error) => {
            this._sweetAlert.errorModal("Error!", true, 'No fue posible obtener la cuota');
          }
        );
    }
  }

  //metodos para recursos bancoldex
  cargarDestinosModalidadBancoldex(i) {
    if (i == 0) {
      this.destinosBancoldex = [];
      this.neoPropuestaIntermediarioBancoldex.propuesta.plazo = null;
      this.neoPropuestaIntermediarioBancoldex.propuesta.tasa = null;
      this.neoPropuestaIntermediarioBancoldex.propuesta.periodicidad = null;
      this.neoPropuestaIntermediarioBancoldex.propuesta.periodoGracia = null;
      this.loadSelectPiker();
    } else {
      this.neoPropuestaIntermediarioBancoldex.propuesta.plazo = 0;
      this.tasaRedescuentoEABancoldex = null;
      this.montoBancoldex = null;
      this.neoPropuestaIntermediarioBancoldex.propuesta.margenIntermediario =
        null;
      this.neoPropuestaIntermediarioBancoldex.propuesta.tasa = null;
      this.neoPropuestaIntermediarioBancoldex.propuesta.periodicidad = 0;
      this.lineasBancoldex.forEach((linea) => {
        if (linea.idModalidad == i) {
          this.neoPropuestaIntermediarioBancoldex.propuesta.modalidad =
            linea.nombreModalidad;
        }
      });
      this._neoParametrosService.getDestinosModalidadBancoldex(i).subscribe(
        (response) => {
          if (response['exitoso']) {
            this.destinosBancoldex = response['data'];
            if (this.editandoPropuestaBancoldex) {
              this.cargarDatosModalidadXDestinoBancoldex(
                this.detalleSolcitud.propuesta.idDestino
              );
            }
          } else {
            this._sweetAlert.errorModal("Error!", true, response['error']);
            this.destinosBancoldex = [];
          }
        },
        (error) => {
          this._sweetAlert.errorModal("Error!", true, 'No fue posible cargar los destinos');
          this.destinosBancoldex = [];
        },
        () => {
          setTimeout(() => {
            $('.selectpicker').selectpicker('refresh');
          });
        }
      );
    }
  }

  cargarDatosModalidadXDestinoBancoldex(i) {
    if (i == 0) {
      this.plazosLineaBancoldex = [];
      this.periodicidadesBancoldex = [];
      this.neoPropuestaIntermediarioBancoldex.propuesta.puntosAdicionales =
        null;
      this.periodosGraciaBancoldex = [];
      this.neoPropuestaIntermediarioBancoldex.propuesta.plazo = null;
      this.neoPropuestaIntermediarioBancoldex.propuesta.tasa = null;
      this.neoPropuestaIntermediarioBancoldex.propuesta.periodicidad = null;
      this.neoPropuestaIntermediarioBancoldex.propuesta.periodoGracia = null;
      this.loadSelectPiker();
    } else {
      if (
        this.neoPropuestaIntermediarioBancoldex.propuesta.idLineaBancoldex != 0
      ) {
        this.destinosBancoldex.forEach((destino) => {
          if (destino.idDestino == i) {
            this.neoPropuestaIntermediarioBancoldex.propuesta.destino =
              destino.nombreDestino;
          }
        });
        this.modalidadXDestino.idModalidad =
          this.neoPropuestaIntermediarioBancoldex.propuesta.idLineaBancoldex;
        this.modalidadXDestino.idDestino = i;
        this.modalidadXDestino.idCliente = this.user.idCliente;

        //CARGAMOS LOS DEMAS SERVICIOS PARA LOS DEMAS SELECT
        this._neoParametrosService
          .getPlazosModalidadBancoldex(this.modalidadXDestino)
          .subscribe(
            (response) => {
              if (response['exitoso']) {
                this.plazosLineaBancoldex = response['data'];
              } else {
                this._sweetAlert.errorModal("Error!", true, response['error']);
                this.plazosLineaBancoldex = [];
              }
            },
            (error) => {
              this._sweetAlert.errorModal("Error!", true, 'No fue posible cargar los plazos');
              this.plazosLineaBancoldex = [];
            },
            () => {
              setTimeout(() => {
                $('.selectpicker').selectpicker('refresh');
              });
            }
          );
        this._neoParametrosService
          .getTiposPeriodicidadModalidadBancoldex(this.modalidadXDestino)
          .subscribe(
            (response) => {
              if (response['exitoso']) {
                this.periodicidadesBancoldex = response['data'];
              } else {
                this._sweetAlert.errorModal("Error!", true, response['error']);
                this.periodicidadesBancoldex = [];
              }
            },
            (error) => {
              this._sweetAlert.errorModal("Error!", true, 'No fue posible cargar las tasas');
              this.tasasLineaPropia = [];
            },
            () => {
              setTimeout(() => {
                $('.selectpicker').selectpicker('refresh');
              });
            }
          );
        this._neoParametrosService
          .getPeriodosGraciaModalidadBancoldex(this.modalidadXDestino)
          .subscribe(
            (response) => {
              if (response['exitoso'] == true) {
                this.periodosGraciaBancoldex = response['data'];
              } else {
                this._sweetAlert.errorModal("Error!", true, response['error']);
                this.periodosGraciaBancoldex = [];
              }
            },
            (error) => {
              this._sweetAlert.errorModal("Error!", true,
                'No fue posible cargar las periodicidades'
              );
              this.periodosGraciaBancoldex = [];
            },
            () => {
              setTimeout(() => {
                $('.selectpicker').selectpicker('refresh');
              });
            }
          );
      }
    }
  }

  cargarTasasRedescuento() {
    if (
      this.modalidadXDestino.idModalidad != null &&
      this.modalidadXDestino.idDestino != null &&
      this.neoPropuestaIntermediarioBancoldex.propuesta.plazo
    ) {
      this.datosTasaBancoldex.idIntermediario = this.user.nit;
      this.datosTasaBancoldex.idModalidad = this.modalidadXDestino.idModalidad;
      this.datosTasaBancoldex.idDestino = this.modalidadXDestino.idDestino;
      this.datosTasaBancoldex.plazoTasa =
        this.neoPropuestaIntermediarioBancoldex.propuesta.plazo;
      this._neoParametrosService
        .getTasaModalidadBancoldex(this.datosTasaBancoldex)
        .subscribe(
          (response) => {
            return new Promise((resolve, reject) => {
              if (response['exitoso']) {
                this.tasaRedescuentoBancoldex = response['data'];
                if (this.tasaRedescuentoBancoldex) {
                  this.neoPropuestaIntermediarioBancoldex.propuesta.codigoTasaRedescuento =
                    this.tasaRedescuentoBancoldex[0].codigoBaseTasaRed;
                  this.neoPropuestaIntermediarioBancoldex.propuesta.puntosAdicionales =
                    this.tasaRedescuentoBancoldex[0].puntosAdicionales;
                  this.neoPropuestaIntermediarioBancoldex.propuesta.tasaRedescuento =
                    this.tasaRedescuentoBancoldex[0].baseTasaRed;
                  this.tasaRedescuentoEABancoldex =
                    this.tasaRedescuentoBancoldex[0].baseTasaRed +
                    ' + ' +
                    this.tasaRedescuentoBancoldex[0].puntosAdicionales;
                  if (
                    DTF_BANCA ==
                    this.tasaRedescuentoBancoldex[0].codigoBaseTasaRed
                  ) {
                    this.cargarTasaBancoldex(String(DTF_T24));
                  } else if (
                    IBR_BANCA ==
                    this.tasaRedescuentoBancoldex[0].codigoBaseTasaRed
                  ) {
                    this.cargarTasaBancoldex(String(IBR_T24));
                  }
                } else {
                  this._sweetAlert.errorModal("Error!", true, 'No se encontró tasa de redescuento');
                }
              } else {
                this._sweetAlert.errorModal("Error!", true, response['error']);
                this.neoPropuestaIntermediarioBancoldex.propuesta.puntosAdicionales =
                  null;
              }
            });
          },
          (error) => {
            this._sweetAlert.errorModal("Error!", true,
              'No fue posible cargar las tasas de redescuento EA'
            );
            this.neoPropuestaIntermediarioBancoldex.propuesta.puntosAdicionales =
              null;
          },
          () => {
            setTimeout(() => {
              $('.selectpicker').selectpicker('refresh');
            });
          }
        );
    }
  }

  cargarTasaBancoldex(codigo) {
    //tasaBancoldex
    this._neoIntermediarioFinancieroService.getTasaBancoldex(codigo).subscribe(
      (response) => {
        if (response['exitoso']) {
          this.tasaBancoldex = Number(response['Tasa']);
          if (!this.tasaBancoldex) {
            this._sweetAlert.errorModal("Error!", true, 'No se encontraron tasas');
            this.tasaBancoldex = 0;
          }
        } else {
          this._sweetAlert.errorModal("Error!", true, response['error']);
          this.destinosBancoldex = [];
        }
      },
      (error) => {
        this._sweetAlert.errorModal("Error!", true, 'No fue posible cargar la tasa');
        this.destinosBancoldex = [];
      }
    );
  }

  calcularTasaTotal() {
    this.neoPropuestaIntermediarioBancoldex.propuesta.margenIntermediario =
      Number(
        this.neoPropuestaIntermediarioBancoldex.propuesta.margenIntermediario
      );
    if (
      this.tasaBancoldex != 0 &&
      this.tasaBancoldex != null &&
      this.neoPropuestaIntermediarioBancoldex.propuesta.puntosAdicionales !=
      null &&
      this.neoPropuestaIntermediarioBancoldex.propuesta.margenIntermediario !=
      0 &&
      this.neoPropuestaIntermediarioBancoldex.propuesta.margenIntermediario !=
      null
    ) {
      this.neoPropuestaIntermediarioBancoldex.propuesta.tasa =
        Number(this.tasaBancoldex.valueOf()) +
        Number(
          this.neoPropuestaIntermediarioBancoldex.propuesta.puntosAdicionales.valueOf()
        ) +
        Number(
          this.neoPropuestaIntermediarioBancoldex.propuesta.margenIntermediario.valueOf()
        );
      this.calcularCuotaBancoldex();
    } else {
      this._sweetAlert.errorModal("Error!", true, 'faltan tasas para calcular la tasa total');
    }
  }

  agregarCargosGarantiasLineaBancoldex() {
    if (
      (this.cargoGarantiasBancoldexNuevo.descripcion != '' || this.cargoGarantiasBancoldexNuevo.idParametrizacionCondicion != 0) &&
      this.cargoGarantiasBancoldexNuevo.idTipoCargo_NeoTipoCargo != 0 &&
      this.cargoGarantiasBancoldexNuevo.monto != null &&
      this.cargoGarantiasBancoldexNuevo.monto != 0 &&
      this.cargoGarantiasBancoldexNuevo.monto
    ) {
      const monto = String(this.cargoGarantiasBancoldexNuevo.monto)
        .replace(',', '')
        .replace(',', '')
        .replace(',', '')
        .replace(',', '')
        .replace('.', '')
        .replace('.', '')
        .replace('.', '')
        .replace('.', '')
        .replace('$', '').trim();
      this.cargoGarantiasBancoldexNuevo.monto = Number(monto);
      this.cargoGarantiasBancoldexNuevoANombre(
        this.cargoGarantiasBancoldexNuevo
      );
      this.cargosGarantiasLineaBancoldex.push(
        this.cargoGarantiasBancoldexNuevo
      );
      if (this.cargoGarantiasBancoldexNuevo.idTipoCargo_NeoTipoCargo == 2) {
        this.neoPropuestaIntermediarioBancoldex.propuesta.desembolsoAproximado =
          this.neoPropuestaIntermediarioBancoldex.propuesta.desembolsoAproximado.valueOf() -
          this.cargoGarantiasBancoldexNuevo.monto.valueOf();
      } else if (
        this.cargoGarantiasBancoldexNuevo.idTipoCargo_NeoTipoCargo == 1
      ) {
        this.neoPropuestaIntermediarioBancoldex.propuesta.cuota =
          this.neoPropuestaIntermediarioBancoldex.propuesta.cuota.valueOf() +
          this.cargoGarantiasBancoldexNuevo.monto.valueOf();
      }
      this.cargoGarantiasBancoldexNuevo = new NeoCargo('', null, 0, 0);
      this.loadSelectPiker();
    } else {
      this._sweetAlert.errorModal("Error!", true, 'Por favor diligencie todos los campos');
      if (!this.cargoGarantiasBancoldexNuevo.monto)
        this.cargoGarantiasBancoldexNuevo.monto = null;
      this.setPipeMontoGarantiaBx();
    }
  }

  borrarCargosGarantiasLineaBancoldex(i) {
    if (this.cargosGarantiasLineaBancoldex[i].idTipoCargo_NeoTipoCargo == 2) {
      this.neoPropuestaIntermediarioBancoldex.propuesta.desembolsoAproximado =
        this.neoPropuestaIntermediarioBancoldex.propuesta.desembolsoAproximado.valueOf() +
        this.cargosGarantiasLineaBancoldex[i].monto.valueOf();
    } else if (
      this.cargosGarantiasLineaBancoldex[i].idTipoCargo_NeoTipoCargo == 1
    ) {
      this.neoPropuestaIntermediarioBancoldex.propuesta.cuota =
        this.neoPropuestaIntermediarioBancoldex.propuesta.cuota.valueOf() -
        this.cargosGarantiasLineaBancoldex[i].monto.valueOf();
    }
    this.cargosGarantiasLineaBancoldex.splice(i, 1);
    this.cargosGarantiasLineaBancoldexConNombre.splice(i, 1);
  }

  cargoGarantiasBancoldexNuevoANombre(cargoGarantiasBancoldexNuevo: NeoCargo) {
    const cargoGarantiaBancoldexNombre = {
      descripcion: '',
      monto: null,
      nombreTipoCargo: '',

    };
    this.tiposCargo.forEach((tipoCargo) => {
      if (
        tipoCargo.idTipoCargo ==
        cargoGarantiasBancoldexNuevo.idTipoCargo_NeoTipoCargo
      ) {
        cargoGarantiaBancoldexNombre.nombreTipoCargo =
          tipoCargo.nombre.toString();
      }
    });
    if (cargoGarantiasBancoldexNuevo.idParametrizacionCondicion != null && cargoGarantiasBancoldexNuevo.idParametrizacionCondicion != 0) {
      this.tiposCondicion.forEach((tipoCondicion) => {
        if (
          tipoCondicion.idParametrizacionCondicion ==
          cargoGarantiasBancoldexNuevo.idParametrizacionCondicion
        ) {
          cargoGarantiaBancoldexNombre.descripcion =
            tipoCondicion.nombre.toString();
          cargoGarantiasBancoldexNuevo.descripcion = tipoCondicion.nombre.toString();
        }
      });

    } else {
      cargoGarantiasBancoldexNuevo.idParametrizacionCondicion = null;
      cargoGarantiaBancoldexNombre.descripcion =
        cargoGarantiasBancoldexNuevo.descripcion.toString();
      cargoGarantiasBancoldexNuevo.descripcion =
        cargoGarantiasBancoldexNuevo.descripcion.toString();

    }

    cargoGarantiaBancoldexNombre.monto = cargoGarantiasBancoldexNuevo.monto;
    this.cargosGarantiasLineaBancoldexConNombre.push(
      cargoGarantiaBancoldexNombre
    );
  }

  calcularCuotaBancoldex() {
    const monto = String(this.montoBancoldex)
      .replace(',', '')
      .replace(',', '')
      .replace(',', '')
      .replace(',', '')
      .replace('.', '')
      .replace('.', '')
      .replace('.', '')
      .replace('.', '')
      .replace('$', '').trim();
    this.neoPropuestaIntermediarioBancoldex.propuesta.monto = Number(monto);
    if (
      this.neoPropuestaIntermediarioBancoldex.propuesta.monto != null &&
      this.neoPropuestaIntermediarioBancoldex.propuesta.monto != 0
    ) {
      this.neoPropuestaIntermediarioBancoldex.propuesta.desembolsoAproximado =
        this.neoPropuestaIntermediarioBancoldex.propuesta.monto;
      if (this.cargosGarantiasLineaBancoldex.length > 0) {
        this.cargosGarantiasLineaBancoldex.forEach((cargoGarantia) => {
          if (cargoGarantia.idTipoCargo_NeoTipoCargo == 2) {
            this.neoPropuestaIntermediarioBancoldex.propuesta.desembolsoAproximado =
              this.neoPropuestaIntermediarioBancoldex.propuesta.desembolsoAproximado.valueOf() -
              cargoGarantia.monto.valueOf();
          }
        });
      }
    }
    if (
      this.neoPropuestaIntermediarioBancoldex.propuesta.monto != null &&
      this.neoPropuestaIntermediarioBancoldex.propuesta.monto != 0 &&
      this.neoPropuestaIntermediarioBancoldex.propuesta.plazo != 0 &&
      this.neoPropuestaIntermediarioBancoldex.propuesta.tasa != 0 &&
      this.neoPropuestaIntermediarioBancoldex.propuesta.tasa != null &&
      this.neoPropuestaIntermediarioBancoldex.propuesta.periodicidad != null
    ) {
      this.neoCalcularCuotaBancoldex.monto =
        this.neoPropuestaIntermediarioBancoldex.propuesta.monto;
      this.neoCalcularCuotaBancoldex.plazo = Number(
        this.neoPropuestaIntermediarioBancoldex.propuesta.plazo
      );
      this.neoCalcularCuotaBancoldex.tasafinalEA = Number(
        this.neoPropuestaIntermediarioBancoldex.propuesta.tasa
      );
      this.neoCalcularCuotaBancoldex.periodicidad = Number(
        this.neoPropuestaIntermediarioBancoldex.propuesta.periodicidad
      );
      this._neoIntermediarioFinancieroService
        .coutaRecursosPropios(this.neoCalcularCuotaBancoldex)
        .subscribe(
          (response) => {
            if (response['exitoso']) {
              this.neoPropuestaIntermediarioBancoldex.propuesta.cuota =
                response['cuotaAproximada'];
              if (this.cargosGarantiasLineaBancoldex.length > 0) {
                this.cargosGarantiasLineaBancoldex.forEach((cargoGarantia) => {
                  if (cargoGarantia.idTipoCargo_NeoTipoCargo == 1) {
                    this.neoPropuestaIntermediarioBancoldex.propuesta.cuota =
                      this.neoPropuestaIntermediarioBancoldex.propuesta.cuota.valueOf() +
                      cargoGarantia.monto.valueOf();
                  }
                });
              }
              this.habilitarCargosGarantiasBancoldex = true;
            }
          },
          (error) => {
          }
        );
    }
  }

  aprobarSolicitudRecBancoldex() {
    if (this.neoPropuestaIntermediarioBancoldex.propuesta.observaciones != '') {
      this._neoIntermediarioFinancieroService
        .crearPropuesta(this.neoPropuestaIntermediarioBancoldex)
        .subscribe(
          (response) => {
            if (response['exitoso']) {
              this._sweetAlert.successModal('¡Éxito!',
                false,
                'La oferta ha sido enviada para aprobación correctamente').then(
                  (result) => {
                    if (result.isConfirmed) {
                      this._router.navigate(['/intermediario/home']);
                    }
                  }
                );
              // Consumir servicio para finalizar auditoria
              this.cerrarTrazabilidad(this.idTrazabilidad);
              // $('#aceptarModal').modal('show');
            } else {
              this._sweetAlert.errorModal("Error!", true, 'No fue posible enviar la propuesta');
            }
          },
          (error) => {
            this._sweetAlert.errorModal("Error!", true, 'No fue posible enviar la propuesta');
          }
        );
    } else {
      this._sweetAlert.errorModal("Error!", true, 'Por favor diligencie las observaciones');
    }
  }

  /** Formato miles con coma sin regex vulnerable (evita ReDoS). */
  formatNumberWithCommas(value: string): string {
    const s = (value || '').replace(/\D/g, '');
    if (!s) return '';
    let out = '';
    for (let i = 0; i < s.length; i++) {
      if (i > 0 && (s.length - i) % 3 === 0) out += ',';
      out += s[i];
    }
    return out;
  }

  setPipeMontoGarantiaBx() {
    $('#montoGarantiaBx').on({
      focus: function (event) {
        $(event.target).select();
      },
      keyup: (event) => {
        $(event.target).val((_i, v) => this.formatNumberWithCommas(v));
      },
    });
  }

  setPipeMontoBx() {
    $('#montoBx').on({
      focus: function (event) {
        $(event.target).select();
      },
      keyup: (event) => {
        $(event.target).val((_i, v) => this.formatNumberWithCommas(v));
      },
    });
  }

  setPipeMontoPropios() {
    $('#montoPropios').on({
      focus: function (event) {
        $(event.target).select();
      },
      keyup: (event) => {
        $(event.target).val((_i, v) => this.formatNumberWithCommas(v));
      },
    });
  }

  setPipeMontoGarantiaPropios() {
    $('#montoGarantiaPropios').on({
      focus: function (event) {
        $(event.target).select();
      },
      keyup: (event) => {
        $(event.target).val((_i, v) => this.formatNumberWithCommas(v));
      },
    });
  }

  downloadAll() {
    const mymeType = 'application/zip';
    this._microempresario
      .downloadAllFile(this.idSolicitud)
      .subscribe((response: any) => {
        if (response.exitoso) {
          let a = document.getElementById('allFile');
          a.setAttribute(
            'href',
            `data:${mymeType};base64,${response.documentos}`
          );
          a.setAttribute('download', 'documentos.zip');
          a.click();
        }
      });
  }

  goBack() {
    this.cerrarTrazabilidad(this.idTrazabilidad);
    this.routerService.goBack();
  }

  alertaModalidadesBancoldex(idSolicitud: any) {
    if (this.idCupoBancoldex == 1) {
      this._neoParametrosService
        .getModalidadesBancoldex(this.user.idCliente, idSolicitud)
        .subscribe(
          (response) => {
            if (response['exitoso'] == true) {
              if (response['data']?.length > 0) {
                this.getMensajeRecursosBancoldex();
                this.getMensajeEconomiaPopular(idSolicitud);
              }
              this.obtenerValorCombo(1);
              this.cargarSucursalesBancoldex();
            } else {
              // this._sweetAlert.errorModal("Error", true, 'Ocurrió un error en el servicio');
              this.obtenerValorCombo(0);
              setTimeout(() => {
                $('.selectpicker').selectpicker('refresh');
              });
            }
          }, () => {
            setTimeout(() => {
              $('.selectpicker').selectpicker('refresh');
            });
          }
          // ,
          // (error) => {
          //   this._sweetAlert.errorModal("Error!", true,
          //     'Ocurrió un error en el servicio'
          //   );
          // },
        );
    } else {
      this.obtenerValorCombo(0);
      setTimeout(() => {
        $('.selectpicker').selectpicker('refresh');
      });
    }
  }

  obtenerValorCombo(numero: number) {
    this.idCupoBancoldexVerificado = numero;
  }

  // Cargar sucursales bancóldex
  cargarSucursalesBancoldex() {
    this._neoParametrosService.getSucursalesBancoldex(
      this._userIntermediarioService.getUser().nit
    ).subscribe((response: any) => {
      if (response.exitoso) {
        this.sucursalesBancoldex = response.data;
      } else {
        this._sweetAlert.errorModal("Error!", true,
          'Ocurrió un error en el servicio'
        );
      }
    }, (error) => {
      this._sweetAlert.errorModal("Error!", true,
        'Ocurrió un error en el servicio'
      );
    });
    setTimeout(() => {
      $('.selectpicker').selectpicker('refresh');
    });
  }
  // mensaje economia popular
  getMensajeEconomiaPopular(idSolicitud: string) {
    this._neoIntermediarioFinancieroService.getMensajeEconomiaPopular(idSolicitud)
      .subscribe((response: any) => {
        if (response.exitoso) {
          this._sweetAlert.successModal(response.message, false);
        } else {
          this._sweetAlert.successModal(this.mensajeRecursosBancoldex, false);
        }
      }, (error) => {
        this._sweetAlert.errorModal("Error", true, "Se presento un error general en el servicio");
      })
  }

  toggleOptions() {
    this.optionsVisible = !this.optionsVisible;
  }

  selectOption(option: number, event: Event) {
    event.stopPropagation(); // Evita la propagación del evento
    this.neoPropuestaIntermediarioPropios.propuesta.tasa = option;
    this.calcularCuota();
    this.optionsVisible = false;
  }

  hideOptions() {
    this.optionsVisible = false;
  }

  validateNumber(event: any) {
    const pattern = /[0-9.]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  validarTasa(event: any) {
    const PATRON_VALOR_TASA = /^[0-9]{1,2}(\.[0-9]{1,2})?$/; // Patrón para 2 dígitos enteros y 2 decimales
    const tasa = this.neoPropuestaIntermediarioPropios.propuesta.tasa;
    if (tasa != null && tasa.toString() != "") {
      const inputValue = event.target.value;
      if (!PATRON_VALOR_TASA.test(inputValue)) {
        this.mensajeError = "La tasa no cumple con el patrón numérico de 2 caracteres entero y 2 decimales.";
        this.errorTasaMax = true;
      } else {
        const inputNumber = parseFloat(inputValue);
        if (isNaN(inputNumber) || inputNumber < 0.01) {
          this.mensajeError = "La tasa es menor que 0.01 o no es un número válido.";
          this.errorTasaMax = true;
        } else if (inputNumber > 99.99) {
          this.mensajeError = "La tasa es mayor que 99.99.";
          this.errorTasaMax = true;
        } else {
          this.errorTasaMax = false;
        }
      }
    } else {
      this.mensajeError = "El campo tasa no tiene un valor asignado.";
      this.errorTasaMax = true;
    }
  }

  getMensajeTasa() {
    const json = {
      idParametro: 'PAR-121',
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        const respuesta = response['data'];
        this.mensajeTasa = String(respuesta[0].valorParametro);
      },
      (error) => {
      }
    );
  }

  getMensajeRecursosBancoldex() {
    const json = {
      idParametro: 'PAR-152',
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        const respuesta = response['data'];
        this.mensajeRecursosBancoldex = String(respuesta[0].valorParametro);
      },
      (error) => {
      }
    );
  }

  // Trazabilidad

  revisionOferta(idEstadoSolicitud: number, negacion: any, propuesta: any) {
    if (idEstadoSolicitud == Constantes.ESTADOS_SOLICITUD.PENDIENTE_PROPUESTAS_ALIADOS &&
      !negacion &&
      !propuesta
    ) {
      const body: NeoTrazabilidadAuditoriaDTO = {
        nombreSeccion: this.isTransaccional ? Constantes.TRANSACCIONAL : Constantes.HOME,
        nombrePantalla: Constantes.CREAR_OFERTA,
        idCliente: +this.user.idCliente,
        idUsuario: +this.user.idUsuario,
        idSolicitud: String(this.idSolicitud),
        perfil: Constantes.PERFIL_ALIADO
      }
      this._serviceTrazabilidad.generarCreacionOferta(body).subscribe(
        {
          next: resp => {
            this.idTrazabilidad = resp.trazabilidad.idTrazabilidad;
          },
          error: err => {
          }
        });
    }
  }

  correccionAprobacionOferta(idEstadoSolicitud: number, negacion: any, propuesta: any) {
    const hayNegacion = negacion != null;
    const hayPropuesta = propuesta != null;

    if (
      idEstadoSolicitud === Constantes.ESTADOS_SOLICITUD.PENDIENTE_PROPUESTAS_ALIADOS &&
      (hayNegacion || hayPropuesta)
    ) {
      const body: NeoTrazabilidadAuditoriaDTO = {
        nombreSeccion: this.isTransaccional ? Constantes.TRANSACCIONAL : Constantes.HOME,
        nombrePantalla: Constantes.CREAR_OFERTA,
        idCliente: +this.user.idCliente,
        idUsuario: +this.user.idUsuario,
        idSolicitud: String(this.idSolicitud),
        perfil: Constantes.PERFIL_ALIADO
      }
      this._serviceTrazabilidad.generarCorreccionAprobacionOferta(body).subscribe(
        {
          next: resp => {
            this.idTrazabilidad = resp.trazabilidad.idTrazabilidad;
          },
          error: err => {
          }
        });
    }
  }

  cerrarTrazabilidad(idTrazabilidad: number) {
    this._serviceTrazabilidad.cierreTrazabilidad(idTrazabilidad).subscribe({
      next: resp => {
      },
      error: err => {
      }
    });
  }
}
